import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PrimengModule } from '../global/primeng.module';

import { DropdownStatesComponent } from './dropdown-states/dropdown-states.component';
import { DateTimeFormatPipe } from './pipe/date-time-format.pipe';
import { PhonePipe } from './pipe/phone.pipe';
import { EmailValidatorDirective } from './validator';
import { ChangeLogHoverOverComponent } from './changelog/changelog-hoverover/changelog-hoverover.component';


@NgModule({
  declarations: [
    DropdownStatesComponent,
    DateTimeFormatPipe,
    PhonePipe,
    EmailValidatorDirective,
    ChangeLogHoverOverComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PrimengModule
  ],
  exports: [
    DropdownStatesComponent, DateTimeFormatPipe, PhonePipe, EmailValidatorDirective, ChangeLogHoverOverComponent
  ]
})
export class SharedModule implements OnInit {
  states: object[] = [];

  ngOnInit() {
  }
 }
